import React from "react";
import { useState } from "../state/useState";
import { order } from "../service/RechargeService";
import { redirectTo } from "../state/action";

export function Message({ history, message }) {

    let [state, dispatch] = useState();


    function onSubmit(value) {
        value.preventDefault();

        order(state.selectedOperator.index, state.phoneNumber, state.amount)
            .then(result => {
                console.log("result", result);
                if (result.success || !result.success) {
                    dispatch(redirectTo(result.redirectTo));
                    history.push("/redirect")
                }
                return result;
            })
            .catch(error => {
                console.log("error", error);
            })
    }

    return <>
        <div className="page_title2">
            <div className="container">

                <div className="title">
                    <h1>Greška kod obrade zahtjeva</h1></div>
            </div>
        </div>
        <div
            className="clearfix">
        </div>
        <div className="container">
            <div className="content_fullwidth">
                <div className="reg_form">
                    <p>
                        <h3 className="nocaps">{message}</h3>
                        <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </p>

                    <div class="left"><a href="javascript:undefined" onClick={() => history.push("/")}
                        class="knowmore_but"><i
                            class="fa fa-hand-o-left fa-lg"></i> NAZAD</a></div>
                </div>
            </div>
        </div>
    </>
}